function companyFilter() {
    let filters = {
        countries: [],
        categories: [],
    };
    
    const countries_areas = document.querySelectorAll('.country-area');
    const countries_categories = document.querySelectorAll('.country-category');
    const company_categories = document.querySelectorAll('.company-category');
    
    countries_areas.forEach(countries_area => {
        countries_area.addEventListener('click', () => {
            const country = countries_area.getAttribute('data-country');

            if(country == undefined || country == '') return;

            const countryCategory = document.querySelector(`.country-category[data-country='${country}']`);
            const companyCategoryAll = document.querySelector(`.company-category-all`);
            
            filters['countries'] = [];
            
            countries_categories.forEach(countries_category => {
                countries_category.classList.remove('active');
            });

            countryCategory.click();
            companyCategoryAll.click();
            
            document.querySelector('.countries-categories').scrollIntoView({
                behavior: 'smooth'
            });

            const elementPosition = document.querySelector('.countries-categories').getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 102;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        })
    })
    
    countries_categories.forEach(countries_category => {
        countries_category.addEventListener('click', () => {
            const country = countries_category.getAttribute('data-country');

            if(countries_category.classList.contains('country-category-all')){
                if(countries_category.classList.contains('active')) {
                    filters['countries'] = [];
                } else{
                    filters['countries'] = [];
                }

                countries_categories.forEach(countries_category => {
                    if(!countries_category.classList.contains('country-category-all')) {
                        countries_category.classList.remove('active');
                    }
                });
            } else{
                if(document.querySelector('.country-category-all').classList.contains('active')) {
                    filters['countries'] = [];
                    document.querySelector('.country-category-all').classList.remove('active');
                }

                const countryIndex = filters['countries'].indexOf(country);

                if(countryIndex === -1){
                    filters['countries'].push(country);
                } else {
                    filters['countries'].splice(countryIndex, 1);
                }
            }

            countries_category.classList.toggle('active');

            filterCompanies(filters);
        })
    })

    company_categories.forEach(company_category => {
        company_category.addEventListener('click', () => {
            const category = company_category.getAttribute('data-category');

            if(company_category.classList.contains('company-category-all')){
                if(company_category.classList.contains('active')) {
                    filters['categories'] = [];
                } else{
                    filters['categories'] = [];
                }

                company_categories.forEach(company_category => {
                    if(!company_category.classList.contains('company-category-all')) {
                        company_category.classList.remove('active');
                    }
                });
            } else{
                if(document.querySelector('.company-category-all').classList.contains('active')) {
                    filters['categories'] = [];
                    document.querySelector('.company-category-all').classList.remove('active');
                }

                const categoryIndex = filters['categories'].indexOf(category);

                if(categoryIndex === -1){
                    filters['categories'].push(category);
                } else {
                    filters['categories'].splice(categoryIndex, 1);
                }
            }
            
            company_category.classList.toggle('active');

            filterCompanies(filters);
        })
    })
}

function filterCompanies(filters){
    if(filters.countries.length == 0){
        document.querySelector('.country-category-all').classList.add('active');
    }
    if(filters.categories.length == 0){
        document.querySelector('.company-category-all').classList.add('active');
    }

    const companies = document.querySelectorAll('.company');
    
    companies.forEach(company => {
        const company_countries = company.getAttribute('data-countries').split(',');
        const company_categories = company.getAttribute('data-categories').split(',');

        if(filters.countries.every(r => company_countries.includes(r)) && filters.categories.every(r => company_categories.includes(r))){
            company.classList.remove('hidden');
        } else{
            company.classList.add('hidden');
        }
    })
}

export { companyFilter }
